(function () {
  'use strict';

  /*
   * La molette reste entièrement native. En particulier, aucun listener
   * global ne doit annuler un geste vertical quand le pointeur survole un
   * carrousel. Les trackpads gardent leur axe horizontal natif, le tactile
   * utilise touch-action: pan-x pan-y et les boutons assurent l'alternative
   * clavier/souris.
   */

  document.querySelectorAll('.carousel').forEach(function (carousel) {
    var viewport = carousel.querySelector('.carousel__viewport');
    if (!viewport) return;

    carousel.querySelectorAll('.nav-btn').forEach(function (button) {
      button.addEventListener('click', function () {
        var first = viewport.querySelector('.carousel__track > *');
        var track = viewport.querySelector('.carousel__track');
        var gap = track ? parseFloat(getComputedStyle(track).columnGap) || 0 : 0;
        var step = first ? first.getBoundingClientRect().width + gap : 300;
        viewport.scrollBy({
          left: step * parseInt(button.dataset.dir, 10),
          behavior: 'smooth'
        });
      });
    });
  });
})();
